import script from "./layout-header-simple.vue?vue&type=script&lang=ts&setup=true"
export * from "./layout-header-simple.vue?vue&type=script&lang=ts&setup=true"

import "./layout-header-simple.vue?vue&type=style&index=0&id=14de2646&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14de2646"]])

export default __exports__